import apple from '../login page/hom1/fruits/apple.jfif'
import banana from '../login page/hom1/fruits/banana.jpg'
import cherry from '../login page/hom1/fruits/cherry.jpeg'
import dragonfruit from '../login page/hom1/fruits/dragonfruit.jpeg'
import grapes from '../login page/hom1/fruits/grapes.jpg'
import guava from '../login page/hom1/fruits/guava.jfif'
import mango from '../login page/hom1/fruits/mango.jpg'
import orange from '../login page/hom1/fruits/orange.jpg'
import strawberry from '../login page/hom1/fruits/strawberry.jpg'
import watermelon from '../login page/hom1/fruits/watermelon.jpg'
import blackberry from '../login page/hom1/fruits/blackberry.jfif'
import coconut from '../login page/hom1/fruits/coconut.jfif'
import pear from '../login page/hom1/fruits/pear.jpg'
import pineapple from '../login page/hom1/fruits/pineapple.jpg'
import pomegranate from '../login page/hom1/fruits/pomegranate.jfif'
import rasberries from '../login page/hom1/fruits/rasberries.jpg'
import wishlist1 from '../login page/hom1/wishlist1.jpg'
import wishlist2 from '../login page/hom1/wishlist2.jpg'
const Fdata = [
    {
        sname: "apple",
        imgscr: apple,
        title: "real veg",
        price:"100/-KG",
        oldprice1: "200/-KG",
        wishlist11:wishlist1,
        wishlist21:wishlist2    
    },
    {
        sname: "banana",
        imgscr: banana,
        title: "real veg",
        price:"20/-KG",
        oldprice1: "30/-KG",
        wishlist11:wishlist1,
        wishlist21:wishlist2
    },
    {
        sname: "cherry",
        imgscr: cherry,
        title: "real veg",
        price:"10/-KG",
        oldprice1: "20/-KG",
         wishlist11:wishlist1,
        wishlist21:wishlist2
    },
    {
        sname: "dragonfruit",
        imgscr: dragonfruit,
        title: "real veg",
        price:"30/-KG",
        oldprice1: "40/-KG",
         wishlist11:wishlist1,
        wishlist21:wishlist2
    },
    {
        sname: "guava",
        imgscr: guava,
        title: "real veg",
        price:"50/-KG",
        oldprice1: "60/-KG",
         wishlist11:wishlist1,
        wishlist21:wishlist2
    },
    {
        sname: "grapes",
        imgscr: grapes,
        title: "real veg",
        price:"70/-KG",
        oldprice1: "80/-KG",
         wishlist11:wishlist1,
        wishlist21:wishlist2
    },
    {
        sname: "mango",
        imgscr: mango,
        title: "real veg",
        price:"90/-KG",
        oldprice1: "100/-KG",
         wishlist11:wishlist1,
        wishlist21:wishlist2
    },
    {
        sname: "orange",
        imgscr: orange,
        title: "real veg",
        price:"15/-KG",
        oldprice1: "25/-KG",
         wishlist11:wishlist1,
        wishlist21:wishlist2
    },
    {
        sname: "pineapple",
        imgscr: pineapple,
        title: "real veg",
        price:"35/-KG",
        oldprice1: "45/-KG",
         wishlist11:wishlist1,
        wishlist21:wishlist2
    },
    {
        sname: "strawberry",
        imgscr: strawberry,
        title: "real veg",
        price:"155/-KG",
        oldprice1: "200/-KG",
         wishlist11:wishlist1,
        wishlist21:wishlist2
    },
    {
        sname: "blackberry",
        imgscr: blackberry,
        title: "real veg",
        price:"75/-KG",
        oldprice1: "100/-KG",
         wishlist11:wishlist1,
        wishlist21:wishlist2
    },
    {
        sname: "watermelon",
        imgscr: watermelon,
        title: "real veg",
        price:"100/-KG",
        oldprice1: "120/-KG",
         wishlist11:wishlist1,
        wishlist21:wishlist2
    },
    {
        sname: "coconut",
        imgscr: coconut,
        title: "real veg",
        price:"130/-KG",
        oldprice1: "150/-KG",
         wishlist11:wishlist1,
        wishlist21:wishlist2
    },
    {
        sname: "pear",
        imgscr: pear,
        title: "real veg",
        price:"150/-KG",
        oldprice1: "200/-KG",
         wishlist11:wishlist1,
        wishlist21:wishlist2
    },
    {
        sname: "pomegranate",
        imgscr: pomegranate,
        title: "real veg",
        price:"70/-KG",
        oldprice1: "100/-KG",
         wishlist11:wishlist1,
        wishlist21:wishlist2
    },
    {
        sname: "rasberries",
        imgscr: rasberries,
        title: "real veg",
        price:"90/-KG",
        oldprice1: "120/-KG",
         wishlist11:wishlist1,
        wishlist21:wishlist2
    },
]

export default Fdata